import styled from 'styled-components'

export const TableDocumentPreviewContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`
